import { FormSectionLayout } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { useRouteParams } from "src/hooks/useRouteParams";
import { GuidedChangeEventPage_ProjectFragment } from "src/routes/projects/change-events/guided/GuidedChangeEventPage.generated";
import { ApplyConfigurationCard_CheckoutConfigFragment } from "src/routes/projects/change-events/guided/workflows/components/ApplyConfigurationCard.generated";
import { ProjectParams } from "src/routes/routesDef";
import { fail, queryResult } from "src/utils";
import {
  SelectConfigurationStep_StructureFragment,
  useSelectConfigurationStepQuery,
} from "./1.SelectConfigurationStep.generated";
import { ApplyConfigurationFormInput } from "./applyConfigurationForm";
import { ConfigurationChangeSection } from "./components/ConfigurationChangeSection";

type SelectConfigurationStepProps = {
  formState: ObjectState<ApplyConfigurationFormInput>;
  project: GuidedChangeEventPage_ProjectFragment;
};

export function SelectConfigurationStep(props: SelectConfigurationStepProps) {
  const { formState, project } = props;
  const { projectId } = useRouteParams<ProjectParams>();
  const query = useSelectConfigurationStepQuery({
    variables: {
      structureId: projectId,
      prpcId: project.readyPlanConfig?.id ?? fail("Project has no ready plan config"),
    },
  });
  return queryResult(query, ({ projectReadyPlanConfig }) => (
    <SelectConfigurationStepView
      structure={project as SelectConfigurationStep_StructureFragment}
      formState={formState}
      currentConfig={projectReadyPlanConfig.checkoutConfig ?? undefined}
    />
  ));
}

type SelectConfigurationStepViewProps = {
  formState: ObjectState<ApplyConfigurationFormInput>;
  structure: SelectConfigurationStep_StructureFragment;
  currentConfig: ApplyConfigurationCard_CheckoutConfigFragment | undefined;
};

function SelectConfigurationStepView(props: SelectConfigurationStepViewProps) {
  const { formState, structure, currentConfig } = props;
  return (
    <FormSectionLayout
      title="Select the Configuration to Apply"
      description="Choose a reserved Checkout configuration to replace the current configuration on this structure."
      sections={[
        {
          title: "Configuration Change",
          fields: (
            <ConfigurationChangeSection formState={formState} structure={structure} currentConfig={currentConfig} />
          ),
        },
      ]}
    />
  );
}
